<template>
  <v-form :style="formStyles" v-bind="$attrs" ref="form" lazy-validation>
    <slot />
  </v-form>
</template>

<script>
export default {
  name: "p-form",

  props: ["outline"],

  computed: {
    formStyles() {
      return {
        "background-color": "var(--v-secondary-base)",

        border: `${this.outline ? "1px solid var(--v-primary-base)" : "none"}`,
        "border-radius": "0 40px 40px 40px",

        height: "fit-content",

        "font-family": "EXO",

        padding: `${this.outline ? "40px" : "0px"}`,
        margin: "30px 0",
      };
    },
  },
};
</script>

<style scoped>
@import "./styles.css";
</style>
